import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import {
  useCheckForwardAccumulatorByTradeCapture,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { selectForwardAccumulatorProperty } from '@/store/forwardAccumulator/selectors.ts';
import { type HedgeType as HedgeTypeTyping, POSSIBLE_HEDGE_TYPE } from '@/store/forwardAccumulator/state.ts';
import { useAppSelector } from '@/store/hooks.ts';

export const HedgeType = () => {
  const tileId = useForwardAccumulatorTileId();
  const check = useCheckForwardAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const hedgeType = useAppSelector((state) => selectForwardAccumulatorProperty(state, tileId, 'hedgeType'));

  const handleHedgeTypeChange = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      sgwtWebAnalytics?.trackEvent(
        'Forward Accumulator',
        'Hedge type changed',
        isDefined(event.target.value) ? event.target.value : 'cleared',
      );
      check({
        hedgeType: event.target.value as HedgeTypeTyping,
      });
    },
    [check, sgwtWebAnalytics],
  );

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.hedgeType">
      <Form.Select value={hedgeType} onChange={handleHedgeTypeChange} size="sm" data-e2e="hedge-selector">
        {POSSIBLE_HEDGE_TYPE.map((hedgeType) => (
          <option key={hedgeType} value={hedgeType}>
            <FormattedMessage id={`targetAccumulator.form.hedgeType.${hedgeType}`} />
          </option>
        ))}
      </Form.Select>
    </TargetAccumulatorFormField>
  );
};
